import React, { useCallback } from 'react';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
import { reflow } from "../../utils/reflow";
import { easeCurves } from "../../motion/eases";
import { MODAL_ENTER_DURATION, MODAL_EXIT_DURATION } from "./animation-constants";
export function Overlay(_ref) {
  var isShowing = _ref.isShowing,
      onRequestClose = _ref.onRequestClose,
      zIndex = _ref.zIndex;
  var handleEnter = useCallback(function (node) {
    reflow(node);
  }, []);
  return /*#__PURE__*/React.createElement(Transition, {
    in: isShowing,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    onEnter: handleEnter,
    timeout: {
      enter: MODAL_ENTER_DURATION,
      exit: MODAL_EXIT_DURATION
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(StyledOverlay, {
      onClick: onRequestClose,
      $zIndex: zIndex,
      "data-state": state
    });
  });
}
var StyledOverlay = styled.div.withConfig({
  displayName: "Overlay__StyledOverlay",
  componentId: "vapor__gvwmjk-0"
})(["position:fixed;z-index:", ";top:0;left:0;right:0;bottom:0;opacity:0;background:rgba(0,0,0,0.5);transition:opacity ", "ms ", ";&[data-state='entering'],&[data-state='entered']{opacity:1;}&[data-state='exiting'],&[data-state='exited']{opacity:0;transition-duration:", "ms;}"], function (p) {
  return p.$zIndex;
}, MODAL_ENTER_DURATION, easeCurves.primary, MODAL_EXIT_DURATION);